// The common approach used to hide information visually but keep them available
// to screen reader and other assistive technology users, is to use CSS that
// will keep the information technically visible but practically hidden.
//
// https://www.w3.org/WAI/tutorials/forms/labels/
export default {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: 1,
}
